import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import { Button, DashboardModule } from '@domain-group/suit-theme'

import { UseCampaignContactsPayload } from '@hooks/useCampaignContacts'
import useCampaignContact from '@hooks/useCampaignContact'

import CampaignContactListItem from './CampaignContactListItem'

interface CampaignContactsProps {
  campaignContactsPayload: UseCampaignContactsPayload,
  campaignId: number,
}

const CampaignContacts = (props: CampaignContactsProps) => {
  const { campaignContactsPayload, campaignId } = props

  const { filteredCampaignContacts, loading } = campaignContactsPayload

  const { callbacks: { createCampaignContactModal } } = useCampaignContact({ campaign_id: campaignId })

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={(
        // @ts-expect-error TS2322
        <DashboardModule.Link href={`#/campaigns/${campaignId}/edit/contacts`}>
          Manage
        </DashboardModule.Link>
      )}
      title="Contacts"
      loading={loading}
    >
      {filteredCampaignContacts.map(contact => (
        <CampaignContactListItem
          key={contact.id}
          campaignContact={contact}
        />
      ))}

      <DashboardModule.Footer boxProps={{ borderTop: 'none' }}>
        <DashboardModule.FooterRight>
          <Button
            buttonStyle="secondaryEdit"
            icon={<FontAwesomeIcon icon={faPlus} />}
            onClick={() => createCampaignContactModal()}
            // @ts-expect-error TS2322
            size={['medium', 'small']}
            width={['100%', 'fit-content']}
          >
            Add Contact
          </Button>
        </DashboardModule.FooterRight>
      </DashboardModule.Footer>
    </DashboardModule>
  )
}

export default CampaignContacts
